//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Features.js";
import "../Features/Features.Feature.js";
let d=[[[0,"Sketch",0,"Sketch",0]],[[[],"GetSketchType",{R_:{sketchType:''}},0,0]],[]];
SPLM.Features.SketchFeature = class extends SPLM.Features.Feature{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Features.SketchFeature";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Features.SketchFeature.SketchType = Object.freeze({
    "Unknown" : "Unknown", "InPlace" : "InPlace", "AlongPath" : "AlongPath", "Extracted" : "Extracted"});

export default SPLM;